<template>
  <v-menu
    v-model="menu"
    :close-on-content-click="false"
    :nudge-right="40"
    lazy
    transition="scale-transition"
    offset-y
    full-width
    min-width="290px"
  >
    <template v-slot:activator="{ on }">
      <v-text-field :value="value" :label="label" prepend-icon="event" readonly v-on="on"></v-text-field>
    </template>
    <v-date-picker :value="value" @input="setInput($event)"></v-date-picker>
  </v-menu>
</template>

<script>
export default {
  props: {
    label: String,
    value: String
  },
  data () {
    return {
      menu: false
    }
  },
  methods: {
    setInput (v) {
      this.menu = false

      this.$emit('input', v)
    }
  }
}
</script>

<style>
</style>
